export default __webpack_public_path__ + "static/media/logo-icon.f000393f.svg";